import { FetchMiddleware, ChirpGateway, LoadBalancer } from '../types';
import { chirpGateways } from '../constants';

interface ChirpContext {
  gateway?: ChirpGateway;
  loadBalancer?: LoadBalancer;
}

export function getPortalId(optionalPath?: string) {
  const portalExpression = /^\/(?:[A-Za-z0-9-_]*)\/(\d+)(?:\/|$)/;
  const portalIdResult = portalExpression.exec(
    optionalPath || document.location.pathname
  );
  const portalId = portalIdResult && portalIdResult[1];
  return portalId || undefined;
}

/**
 * Middleware that adds the portal ID as a query parameter
 * Reads the portal ID from window.hubspot.portal.id
 * Only adds portalId for APP gateway type
 */
export const addPortalIdQueryParam: FetchMiddleware<ChirpContext> = (
  params,
  context
) => {
  // Only add portalId for APP gateway type
  if (context.gateway !== chirpGateways.APP) {
    return params;
  }

  // Check if portal ID is available in window.hubspot.portal.id
  let portalId = (window as any).hubspot?.portal?.id;

  if (portalId === undefined || portalId === null) {
    portalId = getPortalId();
  }

  if (portalId === undefined || portalId === null) {
    // No portal ID available, return params unchanged
    return params;
  }

  // Parse the input URL to add query parameter
  // Since addHost runs first, we should always have absolute URLs
  const inputStr = params.input.toString();
  let url: URL;

  try {
    url = new URL(inputStr);
  } catch {
    // If URL parsing fails, return unchanged
    return params;
  }

  // Add portalId as a query parameter
  url.searchParams.set('portalId', String(portalId));

  return {
    ...params,
    input: url.toString(),
  };
};
